export default "__VITE_ASSET__COx0Y$id__"